import React, { Component } from 'react';
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';
import SubTitulo from '../SubTitulo.jsx';

function ascCompare(a, b, key) {
    if (a[key] > b[key]) {
        return 1;
    }
    if (a[key] < b[key]) {
        return -1;
    }
    
    return 0;
}


function descCompare(a, b, key) {
    if (a[key] < b[key]) {
        return 1;
    }
    if (a[key] > b[key]) {
        return -1;
    }

    return 0;
}

class Table extends Component {

    constructor(props){
        super(props);
        this.SortByKey = this.sortByKey.bind(this);
        this.state = {
            modifiedLimits: this.props.modifiedLimits,
            sortAscending: {
                administradora: true,
                ambito: true
            }
        }
    }
    
    sortByKey(key, asc) {

        const limits = this.state.modifiedLimits;
        const compare = (asc == true) ? ascCompare : descCompare;
        const sortedLimits = limits.sort((a, b) => compare(a, b, key));
        const stateAdm = this.state.sortAscending.administradora;
        const stateAmb = this.state.sortAscending.ambito;
        const sortAscendingAdm = (key == "administradora") ? !stateAdm : stateAdm;
        const sortAscendingAmb = (key == "ambito") ? !stateAmb : stateAmb;

        this.setState({ modifiedLimits: sortedLimits, sortAscending: { administradora: sortAscendingAdm, ambito: sortAscendingAmb } });
    }

    render() {
        if (this.props.modifiedLimits.length <= 0)
            return null;
        else
        {
            return (
                <div>
                    <SubTitle subtitulo="Limites Modificados" />
                    <div className="row">
                        <div className="col-md-12"><hr className="separator-line separator-light" /></div>
                    </div>
                    <label>La modificación de estos límites se enviará cuando finalice esta solicitud. Su aprobación y procesamiento será independiente de la misma.</label>
                    <table className="table table-striped">
                        <TableHeader sortFunction={this.SortByKey} sortAscending={this.state.sortAscending} />
                        <TableBody modifiedLimits={this.state.modifiedLimits} />
                    </table>
                </div>
            );
        }     

    }

}

export default Table;